import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FaqList = ({ items, color = "#45ADE0", prefix = "faq" }) => (
  <Accordion type="single" collapsible className="border-t border-ink/10" data-testid={`${prefix}-list`}>
    {items.map(([q, a], i) => (
      <AccordionItem key={q} value={`i${i}`} className="border-ink/10">
        <AccordionTrigger data-testid={`${prefix}-item-${i}`} className="font-display text-left text-base md:text-lg font-semibold hover:no-underline py-5">
          <span className="flex items-start gap-3"><span className="mt-2 h-2 w-2 shrink-0" style={{ background: color }} />{q}</span>
        </AccordionTrigger>
        <AccordionContent className="text-ink/70 pl-5 text-base leading-relaxed">{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
